import { canAccessCrm } from "../../utils/crmAccess";
import useComposerDraft, { composerDraftKey } from "./useComposerDraft";
import { getCrmColors } from "../../theme/crmColors";
import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import { useMediaQuery, useTheme } from '@material-ui/core';
import { isNil } from "lodash";
import {
  CircularProgress,
  ClickAwayListener,
  IconButton,
  InputBase,
  makeStyles,
  Paper,
  Menu,
  MenuItem,
  Tooltip,
  Fab,
  Button, Dialog, DialogTitle, DialogContent, DialogActions,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import {
  blue,
  green,
  pink,
  grey,
} from "@material-ui/core/colors";
import {
  AttachFile,
  CheckCircleOutline,
  Clear,
  Comment,
  Create,
  Description,
  HighlightOff,
  Mic,
  MicOff,
  Mood,
  MoreVert,
  Send,
  PermMedia,
  Person,
  Reply,
  Duo,
  EventOutlined,
  ViewWeekOutlined,
  LocalOfferOutlined,
} from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import { CameraAlt } from "@material-ui/icons";
import MicRecorder from "mic-recorder-to-mp3";
import clsx from "clsx";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import RecordingTimer from "./RecordingTimer";

import useQuickMessages from "../../hooks/useQuickMessages";
import { isString, isEmpty } from "lodash";
import ContactSendModal from "../ContactSendModal";
import CameraModal from "../CameraModal";
import axios from "axios";

import useCompanySettings from "../../hooks/useSettings/companySettings";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import MessageUploadMedias from "../MessageUploadMedias";
import { EditMessageContext } from "../../context/EditingMessage/EditingMessageContext";
import ScheduleModal from "../ScheduleModal";
import { useHistory } from "react-router-dom";
import SchedulesTheme from "../../pages/Schedules/theme";
import InlineScheduleComposer from "./InlineScheduleComposer";
import InlineKanbanComposer from "./InlineKanbanComposer";
import InlineTagsComposer from "./InlineTagsComposer";
import KanbanTheme from "../../theme/kanbanTheme";
import ComposerCommands from "./ComposerCommands";
import { extractComposerCommand, getCommandSuggestions } from "./scheduleComposer";


const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    position: "relative",
    flexShrink: 0,
    background: theme.ticketDark ? getCrmColors(theme, "dark").surface : (theme.mode === "light" ? "#ffffff" : "#2f2f2f"),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderTop: theme.ticketDark ? `1px solid ${getCrmColors(theme, "dark").border}` : (theme.mode === "light" ? "1px solid #e6edf6" : "1px solid rgba(255,255,255,0.08)"),
    ...(theme.ticketDark ? {
      color: "#FFFFFF",
      "& a": { color: getCrmColors(theme, "dark").accent },
      "& .Mui-disabled .MuiSvgIcon-root": { color: getCrmColors(theme, "dark").muted },
    } : {}),
    "@media (max-width: 767px)": {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      width: "auto",
    },
  },
  avatar: {
    width: "50px",
    height: "50px",
    borderRadius: "25%",
  },
  dropInfo: {
    background: theme.ticketDark ? getCrmColors(theme, "dark").inset : (theme.mode === "light" ? "#edf6ff" : "#343434"),
    color: theme.ticketDark ? "#FFFFFF" : (theme.mode === "light" ? "#172033" : "#f8fafc"),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    padding: 15,
    left: 0,
    right: 0,
  },
  dropInfoOut: {
    display: "none",
  },
  gridFiles: {
    maxHeight: "100%",
    overflow: "scroll",
  },
  newMessageBox: {
    background: theme.ticketDark ? getCrmColors(theme, "dark").surface : (theme.mode === "light" ? "#f0f2f5" : "#111b21"),
    width: "100%",
    display: "flex",
    padding: theme.spacing(0.75, 1),
    alignItems: "center",
    gap: theme.spacing(0.5),
    "& .MuiIconButton-root": {
      borderRadius: 999,
      padding: 8,
      transition: "background-color 0.2s ease, color 0.2s ease",
    },
    "& .MuiIconButton-root:hover": {
      backgroundColor: theme.ticketDark ? getCrmColors(theme, "dark").hover : (theme.mode === "light" ? "rgba(93, 170, 252, 0.12)" : "rgba(255,255,255,0.08)"),
    },
  },
  messageInputWrapper: {
    minHeight: 44,
    padding: theme.spacing(0.25, 0.75),
    marginRight: 0,
    background: theme.ticketDark ? getCrmColors(theme, "dark").inset : (theme.mode === "light" ? "#ffffff" : "#202c33"),
    display: "flex",
    alignItems: "center",
    borderRadius: 24,
    flex: 1,
    position: "relative",
    border: theme.ticketDark ? `1px solid ${getCrmColors(theme, "dark").border}` : (theme.mode === "light" ? "1px solid #d9e2ec" : "1px solid rgba(255,255,255,0.08)"),
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    "&:focus-within": {
      borderColor: theme.ticketDark ? getCrmColors(theme, "dark").accent : "#5daafc",
      boxShadow: theme.mode === "light" ? "0 0 0 2px rgba(93, 170, 252, 0.14)" : "0 0 0 2px rgba(93, 170, 252, 0.18)",
    },
  },
  messageInputWrapperPrivate: {
    minHeight: 44,
    padding: theme.spacing(0.25, 0.75),
    marginRight: 0,
    background: theme.ticketDark ? "#463A23" : (theme.mode === "light" ? "#fff7d6" : "#5b4a1f"),
    display: "flex",
    alignItems: "center",
    borderRadius: 24,
    flex: 1,
    position: "relative",
    border: theme.ticketDark ? `1px solid ${getCrmColors(theme, "dark").stars}` : (theme.mode === "light" ? "1px solid #f4d675" : "1px solid rgba(255,255,255,0.14)"),
  },
  messageInput: {
    paddingLeft: 6,
    paddingRight: 6,
    flex: 1,
    border: "none",
    fontSize: 16,
    lineHeight: 1.35,
    color: theme.ticketDark ? "#FFFFFF" : (theme.mode === "light" ? "#111b21" : "#e9edef"),
    "& input::placeholder, & textarea::placeholder": {
      color: theme.ticketDark ? getCrmColors(theme, "dark").muted : (theme.mode === "light" ? "#667781" : "#8696a0"),
      opacity: 1,
    },

  },
  messageInputPrivate: {
    paddingLeft: 6,
    paddingRight: 6,
    flex: 1,
    border: "none",
    fontSize: 16,
    lineHeight: 1.35,
    color: theme.ticketDark ? "#FFF4D6" : grey[800],
    ...(theme.ticketDark ? {
      "& textarea::placeholder": { color: "#E8D5A7", opacity: 1 },
    } : {}),

  },
  sendMessageIcons: {
    color: theme.ticketDark ? "#FFFFFF" : (theme.mode === "light" ? "#64748b" : "#dbeafe"),
  },
  ForwardMessageIcons: {
    color: theme.ticketDark ? "#FFFFFF" : (theme.mode === "light" ? "#64748b" : "#dbeafe"),
    transform: 'scaleX(-1)'
  },
  uploadInput: {
    display: "none",
  },
  viewMediaInputWrapper: {
    maxHeight: "100%",
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.ticketDark ? getCrmColors(theme, "dark").surface : (theme.mode === 'light' ? "#ffffff" : "#2f2f2f"),
    borderTop: theme.ticketDark ? `1px solid ${getCrmColors(theme, "dark").border}` : (theme.mode === "light" ? "1px solid #e6edf6" : "1px solid rgba(255,255,255,0.08)"),
  },
  emojiBox: {
    position: "absolute",
    bottom: 68,
    width: 40,
    borderTop: theme.ticketDark ? `1px solid ${getCrmColors(theme, "dark").border}` : (theme.mode === "light" ? "1px solid #e8e8e8" : "1px solid rgba(255,255,255,0.08)"),
    zIndex: 3,
    ...(theme.ticketDark ? {
      "& .emoji-mart, & .emoji-mart-bar": {
        backgroundColor: getCrmColors(theme, "dark").surface,
        borderColor: getCrmColors(theme, "dark").border,
        color: "#FFFFFF",
      },
      "& .emoji-mart-category-label span, & .emoji-mart-search input": {
        backgroundColor: getCrmColors(theme, "dark").inset,
        borderColor: getCrmColors(theme, "dark").border,
        color: "#FFFFFF",
      },
      "& .emoji-mart-anchor, & .emoji-mart-search-icon": { color: "#FFFFFF" },
      "& .emoji-mart-preview-shortname, & .emoji-mart-no-results, & .emoji-mart-title-label": { color: getCrmColors(theme, "dark").muted },
      "& .emoji-mart-category .emoji-mart-emoji:hover:before": { backgroundColor: getCrmColors(theme, "dark").hover },
      "& .emoji-mart-search input:focus": { borderColor: getCrmColors(theme, "dark").accent },
      "& .emoji-mart-anchor:focus-visible": { outline: `2px solid ${getCrmColors(theme, "dark").focus}` },
    } : {}),
  },
  circleLoading: {
    color: theme.ticketDark ? "#FFFFFF" : green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },
  audioLoading: {
    color: theme.ticketDark ? "#FFFFFF" : green[500],
    opacity: "70%",
  },
  inputActionCluster: {
    display: "flex",
    alignItems: "center",
  },
  inputEmojiButton: {
    flex: "0 0 auto",
    color: theme.ticketDark ? "#FFFFFF" : (theme.mode === "light" ? "#54656f" : "#aebac1"),
  },
  moreOptionsButton: {
    flex: "0 0 auto",
    color: theme.ticketDark ? "#FFFFFF" : (theme.mode === "light" ? "#54656f" : "#aebac1"),
  },
  audioActionButton: {
    flex: "0 0 auto",
    width: 48,
    height: 48,
    marginLeft: theme.spacing(0.25),
    backgroundColor: theme.ticketDark ? getCrmColors(theme, "dark").selected : "#005AE5",
    color: "#ffffff",
    boxShadow: theme.mode === "light" ? "0 8px 18px rgba(0, 90, 229, 0.28)" : "0 8px 18px rgba(0,0,0,0.26)",
    "&:hover": {
      backgroundColor: theme.ticketDark ? getCrmColors(theme, "dark").accentSoft : "#0048b8",
    },
    "&:disabled": {
      backgroundColor: theme.ticketDark ? getCrmColors(theme, "dark").raised : (theme.mode === "light" ? "#cbd5e1" : "#475569"),
      color: "#ffffff",
    },
  },
  audioActionIcon: {
    fontSize: 28,
  },
  menuItemIcon: {
    color: theme.ticketDark ? "#FFFFFF" : (theme.mode === "light" ? "#54656f" : "#aebac1"),
    marginRight: theme.spacing(1.5),
    fontSize: 22,
  },
  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },
  cancelAudioIcon: {
    color: theme.ticketDark ? "#FF8B96" : "red",
  },
  sendAudioIcon: {
    color: theme.ticketDark ? "#75D5A5" : "green",
  },
  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
    backgroundColor: theme.ticketDark ? getCrmColors(theme, "dark").surface : (theme.mode === "light" ? "#f8fbff" : "#343434"),
  },
  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: theme.ticketDark ? getCrmColors(theme, "dark").raised : (theme.mode === "light" ? "#edf6ff" : "#263f50"), //"rgba(0, 0, 0, 0.05)",
    borderRadius: 8,
    display: "flex",
    position: "relative",
  },
  replyginMsgBody: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },
  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: theme.ticketDark ? getCrmColors(theme, "dark").accent : "#25D366",
  },
  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: theme.ticketDark ? getCrmColors(theme, "dark").accent : "#25D366",
  },
  messageContactName: {
    display: "flex",
    color: theme.ticketDark ? getCrmColors(theme, "dark").accent : "#25D366",
    fontWeight: 500,
  },
  messageQuickAnswersWrapper: {
    margin: 0,
    position: "absolute",
    bottom: "50px",
    background: theme.ticketDark ? getCrmColors(theme, "dark").raised : (theme.mode === "light" ? "#ffffff" : "#343434"),
    padding: 0,
    border: theme.ticketDark ? `1px solid ${getCrmColors(theme, "dark").border}` : (theme.mode === "light" ? "1px solid #d7e1ee" : "1px solid rgba(255,255,255,0.10)"),
    borderRadius: 8,
    boxShadow: theme.mode === "light" ? "0 14px 34px rgba(15, 23, 42, 0.12)" : "0 14px 34px rgba(0,0,0,0.24)",
    left: 0,
    width: "100%",
    "& li": {
      listStyle: "none",
      "& a": {
        display: "block",
        padding: "8px",
        textOverflow: "ellipsis",
        overflow: "hidden",
        maxHeight: "30px",
        "&:hover": {
          background: theme.ticketDark ? getCrmColors(theme, "dark").hover : (theme.mode === "light" ? "#edf6ff" : "#3a3a3a"),
          cursor: "pointer",
        },
      },
    },
  },
  invertedFabMenu: {
    border: "none",
    borderRadius: 50, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    minHeight: "auto",
    width: 40,
    height: 40,
    padding: theme.spacing(1),
    backgroundColor: "transparent",
    color: theme.ticketDark ? "#FFFFFF" : (theme.mode === "light" ? "#64748b" : "#dbeafe"),
    "&:hover": {
      backgroundColor: theme.ticketDark ? getCrmColors(theme, "dark").hover : (theme.mode === "light" ? "#edf6ff" : "#3a3a3a"),
    },
    "&:disabled": {
      backgroundColor: "transparent !important",
    },
  },
  invertedFabMenuMP: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: theme.ticketDark ? "#FFFFFF" : blue[800],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuCont: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    minHeight: "auto",
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: theme.ticketDark ? "#FFFFFF" : blue[500],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuMeet: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    minHeight: "auto",
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: theme.ticketDark ? "#FFFFFF" : green[500],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuDoc: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: theme.ticketDark ? "#FFFFFF" : "#7f66ff",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuCamera: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: theme.ticketDark ? "#FFFFFF" : pink[500],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  flexContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  flexItem: {
    flex: 1,
  },
}));

const MessageInput = ({ ticketId, ticketUuid, ticketStatus, droppedFiles, contactId, ticketChannel, ticketContact, ticketConnection, ticketWhatsappId, ticketLoading = false, requestedTicketUuid = ticketUuid, onTagsSaved }) => {

  const classes = useStyles();
  const theme = useTheme();
  const [mediasUpload, setMediasUpload] = useState([]);
  const isMounted = useRef(true);

  const [showEmoji, setShowEmoji] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const [audioRecorderUnavailable, setAudioRecorderUnavailable] = useState(false);
  const [quickAnswers, setQuickAnswer] = useState([]);
  const [typeBar, setTypeBar] = useState(false);
  const inputRef = useRef();
  const focusAfterSend = useRef(null);
  const attachComposerInput = useCallback(input => {
    inputRef.current = input;
    if (input) input.focus();
  }, []);
  const [onDragEnter, setOnDragEnter] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);
  const { setReplyingMessage, replyingMessage } = useContext(ReplyMessageContext);
  const { setEditingMessage, editingMessage } = useContext(EditMessageContext);
  const { user } = useContext(AuthContext);
  const [appointmentModalOpen, setAppointmentModalOpen] = useState(false);
  const [scheduleViewId, setScheduleViewId] = useState(null);
  const [inlineSchedule, setInlineSchedule] = useState(null), [lastSchedule, setLastSchedule] = useState(null);
  const [inlineKanban, setInlineKanban] = useState(null), [lastKanban, setLastKanban] = useState(null);
  const [inlineTags, setInlineTags] = useState(null), [lastTags, setLastTags] = useState(null);
  const [commandsDismissed, setCommandsDismissed] = useState(false), [commandIndex, setCommandIndex] = useState(0);
  const inlineRef = useRef(), kanbanRef = useRef(), tagsRef = useRef(), currentTicket = useRef({ id: ticketId, uuid: requestedTicketUuid }), history = useHistory();
  currentTicket.current = { id: ticketId, uuid: requestedTicketUuid };
  const ticketUnavailable = ticketLoading || (requestedTicketUuid != null && String(requestedTicketUuid) !== String(ticketUuid));

  const [signMessagePar, setSignMessagePar] = useState(false);
  const { get: getSetting } = useCompanySettings();
  const [signMessage, setSignMessage] = useState(true);
  const [privateMessage, setPrivateMessage] = useState(false);
  const [privateMessageInputVisible, setPrivateMessageInputVisible] = useState(false);
  const draftKey = composerDraftKey({ companyId: user.companyId, userId: user.id,
    ticketId, ticketUuid: requestedTicketUuid || ticketUuid, ready: !ticketUnavailable, privateMessage });
  const [inputMessage, setInputMessage, clearSentDraft] = useComposerDraft(draftKey, !!editingMessage);
  const activeDraftKey = useRef(draftKey);
  activeDraftKey.current = draftKey;

  const [senVcardModalOpen, setSenVcardModalOpen] = useState(false);
  const [showModalMedias, setShowModalMedias] = useState(false);

  const { list: listQuickMessages } = useQuickMessages();


  const isMobile = useMediaQuery('(max-width: 767px)'); // Ajuste o valor conforme necessário
  const [placeholderText, setPlaceHolderText] = useState("");

  // Determine o texto do placeholder com base no ticketStatus
  useEffect(() => {
    const placeholder = i18n.t(ticketStatus === "open" || ticketStatus === "group"
      ? "messagesInput.placeholderOpen" : "messagesInput.placeholderClosed");
    setPlaceHolderText(isMobile && placeholder.length > 20 ? `${placeholder.substring(0, 20)}...` : placeholder);
  }, [ticketStatus, isMobile]);

  const {
    selectedMessages,
    setForwardMessageModalOpen,
    showSelectMessageCheckbox } = useContext(ForwardMessageContext);

  useEffect(() => {
    const sentFrom = focusAfterSend.current;
    if (loading || !sentFrom) return;
    focusAfterSend.current = null;
    // Wait until React re-enables the field; an old send must not focus a new ticket.
    if (!ticketUnavailable && !recording && !showSelectMessageCheckbox &&
      String(sentFrom.id) === String(ticketId) && String(sentFrom.uuid) === String(requestedTicketUuid) &&
      inputRef.current && !inputRef.current.disabled) {
      inputRef.current.focus();
    }
  }, [loading, ticketId, requestedTicketUuid, ticketUnavailable, recording, showSelectMessageCheckbox]);


  const canUseCommands = !ticketUnavailable && !privateMessageInputVisible && !privateMessage && !editingMessage && !replyingMessage && !showSelectMessageCheckbox && !loading && !recording && (ticketStatus === "open" || ticketStatus === "group");
  const crmAllowed = canAccessCrm(user);
  useEffect(() => { if (!crmAllowed) { setInlineKanban(null); setLastKanban(null); } }, [crmAllowed]);
  const canUseKanban = crmAllowed && !ticketUnavailable && !privateMessageInputVisible && !privateMessage && !editingMessage && !replyingMessage && !showSelectMessageCheckbox && !loading && !recording && ["open", "pending"].includes(ticketStatus);
  const canUseTags = !ticketUnavailable && !privateMessageInputVisible && !privateMessage && !editingMessage && !replyingMessage && !showSelectMessageCheckbox && !loading && !recording && ["open", "pending", "group"].includes(ticketStatus);
  const commandItems = canUseCommands && !commandsDismissed ? getCommandSuggestions(inputMessage).filter(item => (item.id !== "kanban" || canUseKanban) && (item.id !== "tags" || canUseTags)) : [];
  const startInlineSchedule = body => {
    if (!canUseCommands) return;
    setInlineSchedule({ ticketId, ticketUuid: ticketUuid || ticketId, draftKey, body, contact: ticketContact || { id: contactId, name: "Cliente atual", channel: ticketChannel }, connection: ticketConnection || { id: ticketWhatsappId, name: "Conexão do atendimento" } });
    setInputMessage(body); setTypeBar(false); setShowEmoji(false); setCommandsDismissed(true);
  };
  const startInlineKanban = body => {
    if (!canUseKanban) return;
    setInlineKanban({ ticketId, ticketUuid: ticketUuid || ticketId, body, contact: ticketContact || { id: contactId, name: "Cliente atual" } });
    setInputMessage(body); setTypeBar(false); setShowEmoji(false); setCommandsDismissed(true); setLastKanban(null);
  };
  const startInlineTags = body => {
    if (!canUseTags) return;
    setInlineTags({ ticketId, ticketUuid: ticketUuid || ticketId, body, contact: ticketContact || { id: contactId, name: "Cliente atual" } });
    setInputMessage(body); setTypeBar(false); setShowEmoji(false); setCommandsDismissed(true); setLastTags(null);
  };
  const handleCommandKey = event => {
    if (!commandItems.length) return;
    if (event.key === "Escape") { event.preventDefault(); setCommandsDismissed(true); return; }
    if (event.key === "ArrowDown" || event.key === "ArrowUp") { event.preventDefault(); setCommandIndex(index => (index + (event.key === "ArrowDown" ? 1 : -1) + commandItems.length) % commandItems.length); }
    if (event.key === "Enter" || event.key === "Tab") { event.preventDefault(); event.stopPropagation(); runComposerCommand(commandItems[commandIndex]); }
  };
  const runComposerCommand = (command, body = "") => {
    if (command?.id === "schedule") startInlineSchedule(body);
    if (command?.id === "kanban") startInlineKanban(body);
    if (command?.id === "tags") startInlineTags(body);
  };

  useEffect(() => {
    if (droppedFiles && droppedFiles.length > 0) {
      const selectedMedias = Array.from(droppedFiles);
      setMediasUpload(selectedMedias);
      setShowModalMedias(true);
    }
  }, [droppedFiles]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
    if (editingMessage) {
      setInputMessage(editingMessage.body);
    }
  }, [replyingMessage, editingMessage]);

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
    return () => {
      setShowEmoji(false);
      setMediasUpload([]);
      setReplyingMessage(null);
      //setSignMessage(true);
      setPrivateMessage(false);
      setPrivateMessageInputVisible(false)
      setEditingMessage(null);
    };
  }, [ticketId, setReplyingMessage, setEditingMessage]);

  useEffect(() => {
    setTimeout(() => {
      if (isMounted.current)
        setOnDragEnter(false);
    }, 1000);
    // eslint-disable-next-line
  }, [onDragEnter === true]);

  //permitir ativar/desativar firma
  useEffect(() => {
    const fetchSettings = async () => {
      const setting = await getSetting({
        "column": "sendSignMessage"
      });

      if (isMounted.current) {
        if (setting.sendSignMessage === "enabled") {
          setSignMessagePar(true);
          const signMessageStorage = JSON.parse(
            localStorage.getItem("persistentSignMessage")
          );
          if (isNil(signMessageStorage)) {
            setSignMessage(true)
          } else {
            setSignMessage(signMessageStorage);
          }
        } else {
          setSignMessagePar(false);
        }
      }
    };
    fetchSettings();
  }, []);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const handleSendLinkVideo = async () => {
    const link = `https://meet.jit.si/${ticketId}`;
    setInputMessage(link);
  }

  const handleChangeInput = (e) => {
    const value = e.target.value, command = extractComposerCommand(value);
    setCommandsDismissed(false); setCommandIndex(0);
    if (command.command && canUseCommands && (command.command.id !== "kanban" || canUseKanban)) runComposerCommand(command.command, command.body);
    else setInputMessage(value);
  };

  const handlePrivateMessage = (e) => {
    setPrivateMessage(!privateMessage);
    setPrivateMessageInputVisible(!privateMessageInputVisible);
  };

  const handleQuickAnswersClick = async (value) => {
    if (value.mediaPath) {
      try {
        const { data } = await api.get(value.mediaPath, {
          responseType: "blob",
        });

        handleUploadQuickMessageMedia(data, value.value);
        setInputMessage("");
        return;
        //  handleChangeMedias(response)
      } catch (err) {
        toastError(err);
      }
    }

    setInputMessage("");
    setInputMessage(value.value);
    setTypeBar(false);
  };

  const handleAddEmoji = (e) => {
    let emoji = e.native;
    setInputMessage((prevState) => prevState + emoji);
  };

  const [modalCameraOpen, setModalCameraOpen] = useState(false);

  const handleCapture = (imageData) => {
    if (imageData) {
      handleUploadCamera(imageData);
    }
  };

  const handleChangeMedias = (e) => {
    if (!e.target.files) {
      return;
    }
    const selectedMedias = Array.from(e.target.files);
    setMediasUpload(selectedMedias);
    setShowModalMedias(true);
  };

  const handleChangeSign = (e) => {
    getStatusSingMessageLocalstogare();
  };

  const handleOpenModalForward = () => {
    if (selectedMessages.length === 0) {
      setForwardMessageModalOpen(false)
      toastError(i18n.t("messagesList.header.notMessage"));
      return;
    }
    setForwardMessageModalOpen(true);
  }

  const getStatusSingMessageLocalstogare = () => {
    const signMessageStorage = JSON.parse(
      localStorage.getItem("persistentSignMessage")
    );
    //si existe uma chave "sendSingMessage"
    if (signMessageStorage !== null) {
      if (signMessageStorage) {
        localStorage.setItem("persistentSignMessage", false);
        setSignMessage(false);
      } else {
        localStorage.setItem("persistentSignMessage", true);
        setSignMessage(true);
      }
    } else {
      localStorage.setItem("persistentSignMessage", false);
      setSignMessage(false);
    }
  };

  const handleInputPaste = (e) => {
    if (e.clipboardData.files[0]) {
      const selectedMedias = Array.from(e.clipboardData.files);
      setMediasUpload(selectedMedias);
      setShowModalMedias(true);
    }
  };

  const handleInputDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files[0]) {
      const selectedMedias = Array.from(e.dataTransfer.files);
      setMediasUpload(selectedMedias);
      setShowModalMedias(true);
    }
  };

  const handleUploadMedia = async (mediasUpload) => {
    setLoading(true);
    // e.preventDefault();

    // Certifique-se de que a variável medias esteja preenchida antes de continuar
    if (!mediasUpload.length) {
      console.log("Nenhuma mídia selecionada.");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("fromMe", true);
    formData.append("isPrivate", privateMessage ? "true" : "false");
    mediasUpload.forEach((media) => {
      formData.append("body", media.caption);
      formData.append("medias", media.file);
    });

    try {
      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
    }

    setLoading(false);
    setMediasUpload([]);
    setShowModalMedias(false);
    setPrivateMessage(false);
    setPrivateMessageInputVisible(false)
  };

  const handleSendContatcMessage = async (vcard) => {
    setSenVcardModalOpen(false);
    setLoading(true);

    if (isNil(vcard)) {
      setLoading(false);
      return;
    }

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: null,
      quotedMsg: replyingMessage,
      isPrivate: privateMessage ? "true" : "false",
      vCard: vcard,
    };
    try {
      await api.post(`/messages/${ticketId}`, message);
    } catch (err) {
      toastError(err);
    }

    setInputMessage("");
    setShowEmoji(false);
    setLoading(false);
    setReplyingMessage(null);
    setEditingMessage(null);
    setPrivateMessage(false);
    setPrivateMessageInputVisible(false);
  };

  const handleSendMessage = async () => {
    if (inlineSchedule || inlineKanban || inlineTags) return;
    if (!privateMessage && !editingMessage && inputMessage.startsWith("//")) {
      const parsed = extractComposerCommand(inputMessage);
      if (canUseCommands) runComposerCommand(parsed.command || commandItems[commandIndex], parsed.command ? parsed.body : "");
      return;
    }
    if (inputMessage.trim() === "") return;
    const sentFrom = { ...currentTicket.current, draftKey, text: inputMessage };
    focusAfterSend.current = sentFrom;
    setLoading(true);

    const userName = privateMessage
      ? `${user.name} - Mensagem Privada`
      : user.name;

    const sendMessage = inputMessage.trim();

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: (signMessage || privateMessage) && !editingMessage
        ? `*${userName}:*\n${sendMessage}`
        : sendMessage,
      quotedMsg: replyingMessage,
      isPrivate: privateMessage ? "true" : "false",
    };

    try {
      if (editingMessage !== null) {
        await api.post(`/messages/edit/${editingMessage.id}`, message);
      } else {
        await api.post(`/messages/${ticketId}`, message);
      }
    } catch (err) {
      toastError(err);
      if (isMounted.current) setLoading(false);
      return;
    }

    if (!editingMessage) clearSentDraft(sentFrom.draftKey, sentFrom.text);
    if (!isMounted.current) return;
    setLoading(false);
    // A response from the previous ticket must not clear the current composer.
    if (activeDraftKey.current !== sentFrom.draftKey ||
      String(currentTicket.current.id) !== String(sentFrom.id) ||
      String(currentTicket.current.uuid) !== String(sentFrom.uuid)) return;
    setShowEmoji(false);
    setReplyingMessage(null);
    setPrivateMessage(false);
    setEditingMessage(null);
    setPrivateMessageInputVisible(false);
    handleMenuItemClick();
  };

  const handleStartRecording = async () => {
    setLoading(true);
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error("MEDIA_DEVICES_UNAVAILABLE");
      }
      await navigator.mediaDevices.getUserMedia({ audio: true });
      await Mp3Recorder.start();
      setAudioRecorderUnavailable(false);
      setRecording(true);
      setLoading(false);
    } catch (err) {
      setAudioRecorderUnavailable(true);
      const errorName = err?.name || err?.message;
      const audioErrorMessages = {
        NotFoundError: "Nenhum microfone foi encontrado nesta maquina. Conecte um microfone e tente novamente.",
        DevicesNotFoundError: "Nenhum microfone foi encontrado nesta maquina. Conecte um microfone e tente novamente.",
        NotAllowedError: "Permissao do microfone negada. Libere o acesso ao microfone no navegador e tente novamente.",
        PermissionDeniedError: "Permissao do microfone negada. Libere o acesso ao microfone no navegador e tente novamente.",
        NotReadableError: "Nao foi possivel acessar o microfone. Ele pode estar em uso por outro aplicativo.",
        TrackStartError: "Nao foi possivel acessar o microfone. Ele pode estar em uso por outro aplicativo.",
        MEDIA_DEVICES_UNAVAILABLE: "O navegador nao liberou acesso ao microfone neste ambiente.",
      };

      toastError(audioErrorMessages[errorName] || "Nao foi possivel iniciar a gravacao de audio. Verifique o microfone e tente novamente.");
      setLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const messages = await listQuickMessages({ companyId, userId: user.id });
      const options = messages.map((m) => {
        let truncatedMessage = m.message;
        if (isString(truncatedMessage) && truncatedMessage.length > 90) {
          truncatedMessage = m.message.substring(0, 90) + "...";
        }
        return {
          value: m.message,
          label: `/${m.shortcode} - ${truncatedMessage}`,
          mediaPath: m.mediaPath,
        };
      });
      if (isMounted.current) {

        setQuickAnswer(options);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      isString(inputMessage) &&
      !isEmpty(inputMessage) &&
      inputMessage.length >= 1
    ) {
      const firstWord = inputMessage.charAt(0);

      if (firstWord === "/" && !inputMessage.startsWith("//")) {
        setTypeBar(firstWord.indexOf("/") > -1);

        const filteredOptions = quickAnswers.filter(
          (m) => m.label.toLowerCase().indexOf(inputMessage.toLowerCase()) > -1
        );
        setTypeBar(filteredOptions);
      } else {
        setTypeBar(false);
      }
    } else {
      setTypeBar(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputMessage]);

  const disableOption = () => {
    return (
      ticketUnavailable || loading ||
      recording ||
      (ticketStatus !== "open" && ticketStatus !== "group")
    );
  };

  const handleUploadCamera = async (blob) => {
    setLoading(true);
    try {
      const formData = new FormData();
      const filename = `${new Date().getTime()}.png`;
      formData.append("medias", blob, filename);
      formData.append("body", privateMessage ? `\u200d` : "");
      formData.append("fromMe", true);

      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
    setLoading(false);
  };

  const handleUploadQuickMessageMedia = async (blob, message) => {
    setLoading(true);
    try {
      const extension = blob.type.split("/")[1];

      const formData = new FormData();
      const filename = `${new Date().getTime()}.${extension}`;
      formData.append("medias", blob, filename);
      formData.append("body", privateMessage ? `\u200d${message}` : message);
      formData.append("fromMe", true);

      if (isMounted.current) {
        await api.post(`/messages/${ticketId}`, formData);
      }
    } catch (err) {
      toastError(err);
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };


  const handleUploadAudio = async () => {

    setLoading(true);
    try {
      const [, blob] = await Mp3Recorder.stop().getMp3();
      if (blob.size < 10000) {
        setLoading(false);
        setRecording(false);
        return;
      }

      const formData = new FormData();
      const filename = ticketChannel === "whatsapp" ? `${new Date().getTime()}.mp3` : `${new Date().getTime()}.m4a`;
      formData.append("medias", blob, filename);
      formData.append("body", filename);
      formData.append("fromMe", true);

      if (isMounted.current) {
        await api.post(`/messages/${ticketId}`, formData);
      }
    } catch (err) {
      toastError(err);
    } finally {
      if (isMounted.current) {
        setLoading(false);
        setRecording(false);
      }
    }
  };

  const handleCloseModalMedias = () => {
    setShowModalMedias(false);
  };
  const handleCancelAudio = async () => {
    try {
      await Mp3Recorder.stop().getMp3();
      setRecording(false);
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event) => {
    setAnchorEl(null);
  };

  const handleOpenOptionsMenuClick = (event) => {
    setOptionsAnchorEl(event.currentTarget);
  };

  const handleOptionsMenuClose = () => {
    setOptionsAnchorEl(null);
  };

  const handleScheduleMenuClick = () => {
    handleOptionsMenuClose();
    setScheduleViewId(null);
    setAppointmentModalOpen(true);
  };
  const handleKanbanMenuClick = () => {
    handleOptionsMenuClose();
    startInlineKanban(inputMessage);
  };
  const handleTagsMenuClick = () => {
    handleOptionsMenuClose(); startInlineTags(inputMessage);
  };

  const handleSignMenuClick = (event) => {
    handleChangeSign(event);
    handleOptionsMenuClose();
  };

  const handlePrivateMenuClick = (event) => {
    handlePrivateMessage(event);
    handleOptionsMenuClose();
  };

  const handleSendContactModalOpen = async () => {
    handleMenuItemClick();
    setSenVcardModalOpen(true);
  };

  const handleCameraModalOpen = async () => {
    handleMenuItemClick();
    setModalCameraOpen(true);
  };

  const handleCancelSelection = () => {
    setMediasUpload([]);
    setShowModalMedias(false);
  };

  const renderReplyingMessage = (message) => {
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          {replyingMessage && (
            <div className={classes.replyginMsgBody}>
              {!message.fromMe && (
                <span className={classes.messageContactName}>
                  {message.contact?.name}
                </span>
              )}
              {message.body}
            </div>
          )
          }
        </div>
        <IconButton
          aria-label="showRecorder"
          component="span"
          disabled={disableOption()}
          onClick={() => {
            setReplyingMessage(null);
            setEditingMessage(null);
            setInputMessage("");
          }}
        >
          <Clear className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  if (inlineSchedule) {
    const differentTicket = String(ticketId) !== String(inlineSchedule.ticketId) || (requestedTicketUuid != null && String(requestedTicketUuid) !== String(inlineSchedule.ticketUuid));
    const isOriginalTicket = () => String(currentTicket.current.id) === String(inlineSchedule.ticketId) && (currentTicket.current.uuid == null || String(currentTicket.current.uuid) === String(inlineSchedule.ticketUuid));
    return <Paper square elevation={0} className={classes.mainWrapper}><SchedulesTheme>
      <InlineScheduleComposer ref={inlineRef} key={inlineSchedule.ticketId} ticketId={inlineSchedule.ticketId} contact={inlineSchedule.contact} connection={inlineSchedule.connection} body={inlineSchedule.body} blocked={differentTicket || ticketUnavailable || (ticketStatus !== "open" && ticketStatus !== "group")} onBodyChange={body => { if (isOriginalTicket()) { setInputMessage(body); setInlineSchedule(current => ({ ...current, body })); } }}
        onCancel={body => { if (isOriginalTicket()) setInputMessage(body); setInlineSchedule(null); setCommandsDismissed(true); }}
        onSaved={record => { clearSentDraft(inlineSchedule.draftKey, inlineSchedule.body); setLastSchedule({ ...record, ticketId: inlineSchedule.ticketId }); setInlineSchedule(null); }} />
      <Dialog open={differentTicket} aria-labelledby="schedule-ticket-change"><DialogTitle id="schedule-ticket-change">Agendamento em edição</DialogTitle><DialogContent>O rascunho pertence a {inlineSchedule.contact.name || "outro cliente"}. Volte ao atendimento original ou descarte antes de continuar.</DialogContent><DialogActions><Button onClick={() => inlineRef.current?.cancel()}>Descartar agendamento</Button><Button color="primary" onClick={() => history.push(`/tickets/${inlineSchedule.ticketUuid}`)}>Voltar ao atendimento</Button></DialogActions></Dialog>
    </SchedulesTheme></Paper>;
  }

  if (inlineKanban && crmAllowed) {
    const differentTicket = String(ticketId) !== String(inlineKanban.ticketId) || (requestedTicketUuid != null && String(requestedTicketUuid) !== String(inlineKanban.ticketUuid));
    const isOriginalTicket = () => String(currentTicket.current.id) === String(inlineKanban.ticketId) && (currentTicket.current.uuid == null || String(currentTicket.current.uuid) === String(inlineKanban.ticketUuid));
    return <Paper square elevation={0} className={classes.mainWrapper}><KanbanTheme>
      <InlineKanbanComposer ref={kanbanRef} key={inlineKanban.ticketId} ticketId={inlineKanban.ticketId} contact={inlineKanban.contact} blocked={differentTicket || ticketUnavailable || !["open", "pending"].includes(ticketStatus)}
        onCancel={({ uncertain }) => { if (isOriginalTicket()) setInputMessage(inlineKanban.body); if (uncertain) setLastKanban({ ticketId: inlineKanban.ticketId, uncertain: true }); setInlineKanban(null); setCommandsDismissed(true); }}
        onSaved={record => { if (isOriginalTicket()) setInputMessage(inlineKanban.body); setLastKanban({ ...record, ticketId: inlineKanban.ticketId }); setInlineKanban(null); setCommandsDismissed(true); }} />
      <Dialog open={differentTicket} aria-labelledby="kanban-ticket-change"><DialogTitle id="kanban-ticket-change">Kanban em edição</DialogTitle><DialogContent>A alteração pertence a {inlineKanban.contact.name || "outro cliente"}. Volte ao atendimento original ou descarte antes de continuar.</DialogContent><DialogActions><Button onClick={() => kanbanRef.current?.cancel()}>Descartar alteração</Button><Button color="primary" onClick={() => history.push(`/tickets/${inlineKanban.ticketUuid}`)}>Voltar ao atendimento</Button></DialogActions></Dialog>
    </KanbanTheme></Paper>;
  }

  if (inlineTags) {
    const differentTicket = String(ticketId) !== String(inlineTags.ticketId) || (requestedTicketUuid != null && String(requestedTicketUuid) !== String(inlineTags.ticketUuid));
    const isOriginalTicket = () => String(currentTicket.current.id) === String(inlineTags.ticketId) && (currentTicket.current.uuid == null || String(currentTicket.current.uuid) === String(inlineTags.ticketUuid));
    return <Paper square elevation={0} className={classes.mainWrapper}><KanbanTheme>
      <InlineTagsComposer ref={tagsRef} key={inlineTags.ticketId} ticketId={inlineTags.ticketId} contact={inlineTags.contact} blocked={differentTicket || ticketUnavailable || !["open", "pending", "group"].includes(ticketStatus)}
        onCancel={({ uncertain }) => { if (isOriginalTicket()) setInputMessage(inlineTags.body); if (uncertain) setLastTags({ ticketId: inlineTags.ticketId, uncertain: true }); setInlineTags(null); setCommandsDismissed(true); }}
        onSaved={record => { if (onTagsSaved) onTagsSaved(record); if (isOriginalTicket()) setInputMessage(inlineTags.body); setLastTags({ ...record, ticketId: inlineTags.ticketId }); setInlineTags(null); setCommandsDismissed(true); }} />
      <Dialog open={differentTicket} aria-labelledby="tags-ticket-change"><DialogTitle id="tags-ticket-change">Tags em edição</DialogTitle><DialogContent>A alteração pertence a {inlineTags.contact.name || "outro cliente"}. Volte ao atendimento original ou descarte antes de continuar.</DialogContent><DialogActions><Button onClick={() => tagsRef.current?.cancel()}>Descartar alteração</Button><Button color="primary" onClick={() => history.push(`/tickets/${inlineTags.ticketUuid}`)}>Voltar ao atendimento</Button></DialogActions></Dialog>
    </KanbanTheme></Paper>;
  }

  if (mediasUpload.length > 0) {
    return (

      <Paper
        elevation={0}
        square
        className={classes.viewMediaInputWrapper}
        onDragEnter={() => setOnDragEnter(true)}
        onDrop={(e) => handleInputDrop(e)}
      >
        {showModalMedias && (
          <MessageUploadMedias
            isOpen={showModalMedias}
            files={mediasUpload}
            onClose={handleCloseModalMedias}
            onSend={handleUploadMedia}
            onCancelSelection={handleCancelSelection}
          />
        )}

      </Paper>
    )
  }
  else {
    return (
      <>
        {modalCameraOpen && (
          <CameraModal
            isOpen={modalCameraOpen}
            onRequestClose={() => setModalCameraOpen(false)}
            onCapture={handleCapture}
          />
        )}
        {senVcardModalOpen && (
          <ContactSendModal
            modalOpen={senVcardModalOpen}
            onClose={(c) => {
              handleSendContatcMessage(c);
            }}
          />
        )}
        <Paper
          square
          elevation={0}
          className={classes.mainWrapper}
          onDragEnter={() => setOnDragEnter(true)}
          onDrop={(e) => handleInputDrop(e)}
        >
          {commandItems.length > 0 && <ComposerCommands items={commandItems} selectedIndex={commandIndex} onSelect={runComposerCommand} />}
          {lastSchedule && String(lastSchedule.ticketId) === String(ticketId) && <Alert severity="success" style={{ width: "100%", boxSizing: "border-box" }} action={<Button size="small" onClick={() => { setScheduleViewId(lastSchedule.id); setAppointmentModalOpen(true); }}>Ver agendamento</Button>}>Agendado para {new Date(lastSchedule.sendAt).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}</Alert>}
          {crmAllowed && lastKanban && String(lastKanban.ticketId) === String(ticketId) && <Alert severity={lastKanban.uncertain ? "warning" : "success"} onClose={() => setLastKanban(null)} style={{ width: "100%", boxSizing: "border-box" }} action={lastKanban.uncertain && <Button size="small" disabled={!canUseKanban} onClick={() => startInlineKanban(inputMessage)}>Conferir</Button>}>{lastKanban.uncertain ? "A movimentação pode ter sido registrada. Confira a etapa atual do card." : `Movimentação registrada: ${lastKanban.stageName}`}</Alert>}
          {lastTags && String(lastTags.ticketId) === String(ticketId) && <Alert severity={lastTags.uncertain ? "warning" : "success"} onClose={() => setLastTags(null)} style={{ width: "100%", boxSizing: "border-box" }} action={lastTags.uncertain && <Button size="small" disabled={!canUseTags} onClick={() => startInlineTags(inputMessage)}>Conferir</Button>}>{lastTags.uncertain ? "A alteração pode ter sido registrada. Confira as tags atuais do cliente." : "Tags do cliente atualizadas."}</Alert>}
          {(replyingMessage && renderReplyingMessage(replyingMessage)) || (editingMessage && renderReplyingMessage(editingMessage))}
          <div className={classes.newMessageBox}>
            <div className={classes.inputActionCluster}>
              <Fab
                disabled={disableOption()}
                aria-label="uploadMedias"
                component="span"
                className={classes.invertedFabMenu}
                onClick={handleOpenMenuClick}
              >
                <AddIcon />
              </Fab>
              <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleMenuItemClick}
                id="simple-menu"
              >
                <MenuItem onClick={handleMenuItemClick}>
                  <input
                    multiple
                    type="file"
                    id="upload-img-button"
                    accept="image/*, video/*, audio/* "
                    // disabled={disableOption()}
                    className={classes.uploadInput}
                    onChange={handleChangeMedias}
                  />
                  <label htmlFor="upload-img-button">
                    <Fab
                      aria-label="upload-img"
                      component="span"
                      className={classes.invertedFabMenuMP}
                    >
                      <PermMedia />
                    </Fab>
                    {i18n.t("messageInput.type.imageVideo")}
                  </label>
                </MenuItem>
                <MenuItem onClick={handleCameraModalOpen}>
                  <Fab className={classes.invertedFabMenuCamera}>
                    <CameraAlt />
                  </Fab>
                  {i18n.t("messageInput.type.cam")}
                </MenuItem>
                <MenuItem onClick={handleMenuItemClick}>
                  <input
                    multiple
                    type="file"
                    id="upload-doc-button"
                    accept="application/*, text/*"
                    // disabled={disableOption()}
                    className={classes.uploadInput}
                    onChange={handleChangeMedias}
                  />
                  <label htmlFor="upload-doc-button">
                    <Fab aria-label="upload-img"
                      component="span" className={classes.invertedFabMenuDoc}>
                      <Description />
                    </Fab>
                    Documento
                  </label>
                </MenuItem>
                <MenuItem onClick={handleSendContactModalOpen}>
                  <Fab className={classes.invertedFabMenuCont}>
                    <Person />
                  </Fab>
                  {i18n.t("messageInput.type.contact")}
                </MenuItem>
                <MenuItem onClick={handleSendLinkVideo}>
                  <Fab className={classes.invertedFabMenuMeet}>
                    <Duo />
                  </Fab>
                  {i18n.t("messageInput.type.meet")}
                </MenuItem>
              </Menu>
              {/* <IconButton
				  aria-label="upload"
				  component="span"
				  disabled={disableOption()}
				  onMouseOver={() => setOnDragEnter(true)}
				>
				  <AttachFile className={classes.sendMessageIcons} />
				</IconButton> */}

              {/* </label> */}
              {/* <Tooltip title={i18n.t("messageInput.tooltip.meet")}>
                <IconButton
                  aria-label="send-upload"
                  component="span"
                  onClick={handleSendLinkVideo}
                >
                  <Duo style={{ color: "grey" }} />
                </IconButton>
              </Tooltip> */}
            </div>
            {false && (<>
              <IconButton
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleOpenMenuClick}
              >
                <MoreVert></MoreVert>
              </IconButton>
              <Menu
                id="simple-menu"
                keepMounted
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuItemClick}
              >
                <MenuItem onClick={handleMenuItemClick}>
                  <IconButton
                    aria-label="emojiPicker"
                    component="span"
                    disabled={disableOption()}
                    onClick={(e) => setShowEmoji((prevState) => !prevState)}
                  >
                    <Mood className={classes.sendMessageIcons} />
                  </IconButton>
                </MenuItem>
                <MenuItem onClick={handleMenuItemClick}>
                  <input
                    multiple
                    type="file"
                    id="upload-button"
                    disabled={disableOption()}
                    className={classes.uploadInput}
                    onChange={handleChangeMedias}
                  />
                  <label htmlFor="upload-button">
                    <IconButton
                      aria-label="upload"
                      component="span"
                      disabled={disableOption()}
                    >
                      <AttachFile className={classes.sendMessageIcons} />
                    </IconButton>
                  </label>
                </MenuItem>
                {signMessagePar && (
                  <Tooltip title="Habilitar/Desabilitar Assinatura">
                    <IconButton
                      aria-label="send-upload"
                      component="span"
                      onClick={handleChangeSign}
                    >
                      {signMessage === true ? (
                        <Create style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#EEE" }} />
                      ) : (
                        <Create style={{ color: "grey" }} />
                      )}
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title="Habilitar/Desabilitar Comentários">
                  <IconButton
                    aria-label="send-upload"
                    component="span"
                    onClick={handlePrivateMessage}
                  >
                    {privateMessage === true ? (
                      <Comment style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#EEE" }} />
                    ) : (
                      <Comment style={{ color: "grey" }} />
                    )}
                  </IconButton>
                </Tooltip>
              </Menu>
            </>)}
            <div className={classes.flexContainer}>
              {privateMessageInputVisible && (
                <div className={classes.flexItem}>
                  <div className={classes.messageInputWrapperPrivate}>
                    <IconButton
                      aria-label="emojiPicker"
                      component="span"
                      className={classes.inputEmojiButton}
                      disabled={disableOption()}
                      onClick={(e) => setShowEmoji((prevState) => !prevState)}
                    >
                      <Mood className={classes.sendMessageIcons} />
                    </IconButton>
                    {showEmoji ? (
                      <div className={classes.emojiBox}>
                        <ClickAwayListener onClickAway={(e) => setShowEmoji(false)}>
                          <Picker
                            perLine={16}
                            color={theme.ticketDark ? getCrmColors(theme, "dark").accent : undefined}
                            theme={"dark"}
                            i18n={i18n}
                            showPreview={true}
                            showSkinTones={false}
                            onSelect={handleAddEmoji}
                          />
                        </ClickAwayListener>
                      </div>
                    ) : null}
                    <InputBase
                      inputRef={attachComposerInput}
                      className={classes.messageInputPrivate}
                      placeholder={
                        ticketStatus === "open" || ticketStatus === "group"
                          ? i18n.t("messagesInput.placeholderPrivateMessage")
                          : i18n.t("messagesInput.placeholderClosed")
                      }
                      multiline
                      maxRows={5}
                      value={inputMessage}
                      onChange={handleChangeInput}
                      onKeyDown={handleCommandKey}
                      disabled={disableOption()}
                      onPaste={(e) => {
                        (ticketStatus === "open" || ticketStatus === "group") &&
                          handleInputPaste(e);
                      }}
                      onKeyPress={(e) => {
                        if (loading || e.shiftKey) return;
                        else if (e.key === "Enter") {
                          handleSendMessage();
                        }
                      }}

                    />
                    {typeBar ? (
                      <ul className={classes.messageQuickAnswersWrapper}>
                        {typeBar.map((value, index) => {
                          return (
                            <li
                              className={classes.messageQuickAnswersWrapperItem}
                              key={index}
                            >
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                              <a onClick={() => handleQuickAnswersClick(value)}>
                                {`${value.label} - ${value.value}`}
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              )}
              {!privateMessageInputVisible && (
                <div className={classes.flexItem}>
                  <div className={classes.messageInputWrapper}>
                    <IconButton
                      aria-label="emojiPicker"
                      component="span"
                      className={classes.inputEmojiButton}
                      disabled={disableOption()}
                      onClick={(e) => setShowEmoji((prevState) => !prevState)}
                    >
                      <Mood className={classes.sendMessageIcons} />
                    </IconButton>
                    {showEmoji ? (
                      <div className={classes.emojiBox}>
                        <ClickAwayListener onClickAway={(e) => setShowEmoji(false)}>
                          <Picker
                            perLine={16}
                            color={theme.ticketDark ? getCrmColors(theme, "dark").accent : undefined}
                            theme={"dark"}
                            i18n={i18n}
                            showPreview={true}
                            showSkinTones={false}
                            onSelect={handleAddEmoji}
                          />
                        </ClickAwayListener>
                      </div>
                    ) : null}
                    <InputBase
                      inputRef={attachComposerInput}
                      className={classes.messageInput}
                      placeholder={placeholderText}
                      multiline
                      maxRows={5}
                      value={inputMessage}
                      onChange={handleChangeInput}
                      onKeyDown={handleCommandKey}
                      inputProps={{ "aria-controls": commandItems.length ? "composer-commands" : undefined, "aria-expanded": commandItems.length > 0, "aria-activedescendant": commandItems[commandIndex] ? `composer-command-${commandItems[commandIndex].id}` : undefined }}
                      disabled={disableOption()}
                      onPaste={(e) => {
                        (ticketStatus === "open" || ticketStatus === "group") &&
                          handleInputPaste(e);
                      }}
                      onKeyPress={(e) => {
                        if (loading || e.shiftKey) return;
                        else if (e.key === "Enter") {
                          handleSendMessage();
                        }
                      }}
                    />
                    {typeBar ? (
                      <ul className={classes.messageQuickAnswersWrapper}>
                        {typeBar.map((value, index) => {
                          return (
                            <li
                              className={classes.messageQuickAnswersWrapperItem}
                              key={index}
                            >
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                              <a onClick={() => handleQuickAnswersClick(value)}>
                                {`${value.label} - ${value.value}`}
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <Tooltip title="Opcoes da mensagem">
              <IconButton
                aria-label="Opções da mensagem"
                aria-controls="message-options-menu"
                aria-haspopup="true"
                className={classes.moreOptionsButton}
                onClick={handleOpenOptionsMenuClick}
              >
                <MoreVert />
              </IconButton>
            </Tooltip>
            <Menu
              id="message-options-menu"
              keepMounted
              anchorEl={optionsAnchorEl}
              open={Boolean(optionsAnchorEl)}
              onClose={handleOptionsMenuClose}
            >
              <MenuItem
                onClick={handleScheduleMenuClick}
                disabled={loading || privateMessageInputVisible}
              >
                <EventOutlined className={classes.menuItemIcon} />
                {i18n.t("tickets.buttons.scredule")}
              </MenuItem>
              {crmAllowed && <MenuItem onClick={handleKanbanMenuClick} disabled={!canUseKanban}>
                <ViewWeekOutlined className={classes.menuItemIcon} />
                Kanban
              </MenuItem>}
              <MenuItem onClick={handleTagsMenuClick} disabled={!canUseTags}>
                <LocalOfferOutlined className={classes.menuItemIcon} />
                Tags do cliente
              </MenuItem>
              {signMessagePar && (
                <MenuItem onClick={handleSignMenuClick}>
                  <Create
                    className={classes.menuItemIcon}
                  />
                  {signMessage ? "Desabilitar assinatura" : "Habilitar assinatura"}
                </MenuItem>
              )}
              <MenuItem onClick={handlePrivateMenuClick}>
                <Comment
                  className={classes.menuItemIcon}
                  style={{ color: privateMessage ? (theme.ticketDark ? getCrmColors(theme, "dark").stars : "#5daafc") : undefined }}
                />
                {privateMessage ? "Desabilitar mensagem privada" : "Habilitar mensagem privada"}
              </MenuItem>
            </Menu>
            {!privateMessageInputVisible && (
              <>
                {inputMessage || showSelectMessageCheckbox ? (
                  <>
                    <IconButton
                      aria-label="sendMessage"
                      component="span"
                      onClick={showSelectMessageCheckbox ? handleOpenModalForward : handleSendMessage}
                      disabled={loading}
                    >
                      {showSelectMessageCheckbox ?
                        <Reply className={classes.ForwardMessageIcons} /> : <Send className={classes.sendMessageIcons} />}
                    </IconButton>
                  </>
                ) : recording ? (
                  <div className={classes.recorderWrapper}>
                    <IconButton
                      aria-label="cancelRecording"
                      component="span"
                      fontSize="large"
                      disabled={loading}
                      onClick={handleCancelAudio}
                    >
                      <HighlightOff className={classes.cancelAudioIcon} />
                    </IconButton>
                    {loading ? (
                      <div>
                        <CircularProgress className={classes.audioLoading} />
                      </div>
                    ) : (
                      <RecordingTimer />
                    )}

                    <IconButton
                      aria-label="sendRecordedAudio"
                      component="span"
                      onClick={handleUploadAudio}
                      disabled={loading}
                    >
                      <CheckCircleOutline className={classes.sendAudioIcon} />
                    </IconButton>
                  </div>
                ) : (
                  <IconButton
                    aria-label="showRecorder"
                    component="span"
                    className={classes.audioActionButton}
                    disabled={disableOption()}
                    onClick={handleStartRecording}
                  >
                    {audioRecorderUnavailable ? (
                      <MicOff className={classes.audioActionIcon} />
                    ) : (
                      <Mic className={classes.audioActionIcon} />
                    )}
                  </IconButton>
                )}
              </>
            )}

            {privateMessageInputVisible && (
              <>
                <IconButton
                  aria-label="sendMessage"
                  component="span"
                  onClick={showSelectMessageCheckbox ? handleOpenModalForward : handleSendMessage}
                  disabled={loading}
                >
                  {showSelectMessageCheckbox ?
                    <Reply className={classes.ForwardMessageIcons} /> : <Send className={classes.sendMessageIcons} />}
                </IconButton>
              </>
            )}
            {appointmentModalOpen && (
              <ScheduleModal
                open={appointmentModalOpen}
                onClose={() => setAppointmentModalOpen(false)}
                message={inputMessage}
                contactId={contactId}
                scheduleId={scheduleViewId || undefined}
              />
            )}
          </div>
        </Paper>
      </>
    );
  }
};

export default MessageInput;
